import { HeightRestrictionFeatureCollection } from "./models/HeightRestrictionFeatureCollection";

export type HeightRestrictionConfig = {
    URL: string
}

export const heightRestrictionConfig : HeightRestrictionConfig = {
    URL: process.env.REACT_APP_HEIGHTRESTRICTION_URL_PROD as string
};

export async function getHeightRestrictions(minHeight: number){
    const promise = await fetch(heightRestrictionConfig.URL + minHeight);
    const data = await promise.json() as HeightRestrictionFeatureCollection;
        
    return data;
}
